<template>
    <div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="form-label">Columnas</label>
                <select class="form-select" :value="modelValue.columns" @change="onColumnsChange($event.target.value)">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                </select>
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Padding</label>
                <input class="form-control" type="text" :value="modelValue.padding"
                    @input="update('padding', $event.target.value)">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Alineacion</label>
                <select class="form-select" :value="modelValue.align" @change="update('align', $event.target.value)">
                    <option value="left">Izquierda</option>
                    <option value="center">Centro</option>
                    <option value="right">Derecha</option>
                </select>
            </div>
        </div>
        <div class="mb-3">
            <label class="form-label">Color de fondo</label>
            <div class="d-flex gap-2 align-items-center">
                <input class="form-control" type="text" :value="modelValue.backgroundColor"
                    @input="update('backgroundColor', $event.target.value)" placeholder="#FFFFFF">
                <input class="form-control form-control-color" type="color"
                    :value="modelValue.backgroundColor || '#ffffff'"
                    @input="update('backgroundColor', $event.target.value)">
            </div>
        </div>
        <div class="mb-3">
            <label class="form-label">Alto de la fila</label>
            <input class="form-control" type="text" :value="modelValue.rowHeight"
                @input="update('rowHeight', $event.target.value)" placeholder="auto o 120px">
        </div>
        <div v-for="index in columnCount" :key="index" class="mb-3">
            <label class="form-label">Ancho columna {{ index }}</label>
            <input class="form-control" type="text" :value="currentWidth(index - 1)"
                @input="updateWidth(index - 1, $event.target.value)">
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockColumnsEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    computed: {
        columnCount() {
            const count = Number(this.modelValue.columns);
            if (Number.isFinite(count)) {
                return Math.min(Math.max(count, 1), 3);
            }
            return 1;
        },
    },
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
        updateWidth(index, value) {
            const widths = Array.isArray(this.modelValue.widths)
                ? [...this.modelValue.widths]
                : [];
            widths[index] = value;
            this.$emit('update:modelValue', { ...this.modelValue, widths });
        },
        currentWidth(index) {
            const widths = Array.isArray(this.modelValue.widths) ? this.modelValue.widths : [];
            const count = this.columnCount;
            if (widths[index]) {
                return widths[index];
            }
            if (count === 2) {
                return '50%';
            }
            if (count === 3) {
                return '33.33%';
            }
            return '100%';
        },
        onColumnsChange(value) {
            const columns = Number(value);
            const count = Number.isFinite(columns) ? Math.min(Math.max(columns, 1), 3) : 1;
            const contents = Array.isArray(this.modelValue.contents)
                ? [...this.modelValue.contents]
                : [];
            const widths = Array.isArray(this.modelValue.widths)
                ? [...this.modelValue.widths]
                : [];
            while (contents.length < count) {
                contents.push('');
            }
            if (contents.length > count) {
                contents.length = count;
            }
            while (widths.length < count) {
                widths.push(count === 2 ? '50%' : count === 3 ? '33.33%' : '100%');
            }
            if (widths.length > count) {
                widths.length = count;
            }
            this.$emit('update:modelValue', { ...this.modelValue, columns: count, contents, widths });
        },
    },
};
</script>
